// ** UseJWT import to get config
import useJwt from "@src/auth/jwt/useJwt";
import { redirect } from "react-router-dom";
import { resetAllTicketsFilterAction } from "../filters";
import { closeModalPop } from "../modal";
import AppNavigation from "@src/models/NavigationModel";
import { handleSessionEvent } from "../layout";

const config = useJwt.jwtConfig;
/**
 * USER PREFERENCE FOR TICKETS LISTING
 * @param {Object} preferencePayload
 * @returns
 */
export const setUserPreference = (preferencePayload) => (dispatch) => {
  return dispatch({ type: "SET_USER_PREFERENCE", payload: preferencePayload });
};

// ** Handle User Logout
export const handleLogout = () => {
  console.log("handleLogout action called");  
  return (dispatch) => {
    let scheduledEvent = null;
    try {
      const rawScheduledEvent = localStorage.getItem("scheduledEvent");
      scheduledEvent = rawScheduledEvent ? JSON.parse(rawScheduledEvent) : null;
    } catch (error) {
      scheduledEvent = null;
    }

    if (scheduledEvent?.timeout) {
      clearTimeout(scheduledEvent.timeout);
    }

    localStorage.clear();
  console.log("handleLogout 4");  

    dispatch({
      type: "LOGOUT",
    });
  console.log("handleLogout 5");  

    dispatch(closeModalPop());
  console.log("handleLogout 6");  
    dispatch(resetAllTicketsFilterAction());
  console.log("handleLogout 7");  
    dispatch(handleSessionEvent(false));
  console.log("handleLogout 8");  
    dispatch({ type: "set_all_user_organizations", value: [] });
  console.log("handleLogout 9");  
    console.log("User logged out. Redirecting to login page...");
    if (AppNavigation.navigate) {
      AppNavigation.navigate("/login");
    } else {
      redirect("/login");
    }
  };
};
